import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { initDocsScroll } from 'src/app/utils/docs-scroll.util';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent implements OnInit {
  version: string = environment.version;

  constructor() {}

  ngOnInit(): void {}

  // Added the routerLink as an arg, in case we add more links to the footer in the future
  protected onFooterRouterLinkClicked(routerLink: string): void {
    switch (routerLink) {
      case '/docs':
        initDocsScroll(0);

        setTimeout(() => {
          const topHeading: HTMLHeadingElement | null = document.getElementById(
            'docs-top-heading'
          ) as HTMLHeadingElement | null;

          topHeading?.focus({ preventScroll: true });
        }, 50);

        break;

      default:
        return;
    }
  }
}
